module.exports = __webpack_public_path__ + "media/images/consumer/signup/plans/meal-kit-plan-widget-79cb4439c17e4feeed5de0c82fdc5204.jpg";